<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped></style>